import type { LessonOrderItem, UpdateLessonOrderInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useCourseLessonOrder(courseId: string) {
  return useQuery({
    queryKey: ['course-lesson-order', courseId],
    queryFn: () => api.get<LessonOrderItem[]>(`/api/courses/${courseId}/lesson-order`),
    enabled: !!courseId,
  })
}

export function useUpdateLessonOrder(courseId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateLessonOrderInput) =>
      api.put(`/api/courses/${courseId}/lesson-order`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['course-lesson-order', courseId] })
      qc.invalidateQueries({ queryKey: ['learn', courseId] })
    },
  })
}
